import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-form-card',
    templateUrl: './form-card.component.html',
    styleUrls: ['./form-card.component.scss'],
    standalone: false
})
export class FormCardComponent {
  @Input() cardClass: string | undefined;
}
